import React from 'react';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import Toolbar from './Toolbar';
import AutoStatusBanner from './AutoStatusBanner';
import AutoLinker from './Tools/AutoLinker';
import FlaggedNotes from '../../FormControls/FlaggedNotes/FlaggedNotes';
import { RevUserContext, RevUserContextType } from '../../../../context/UserContext';

const TicketHeader: React.FC<ITicketProps> = (details) => {
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    return (
        <Card>
            <CardHeader className='main-header d-flex'>
                <Toolbar  {...details} />
            </CardHeader>
            <CardBody className='p-0'>
                {details?.Is_Loading ?
                    <>
                        {/* <Skeleton shape="rectangle" style={{ width: '100%', height: '100px', marginTop: '10px' }} /> */}
                        <h6 className='description'>...</h6></>
                    : <>
                        <h6 className='description'><AutoLinker text={details?.Call_Desc?.replaceAll('\n', '<br>')} /></h6>
                        <AutoStatusBanner ticket={details} />
                        {!profile?.Features.External_Interface && <FlaggedNotes ticket={details} showPopup={false} showNotes={true} />}
                    </>
                }
            </CardBody>
        </Card>
    );
};

export default TicketHeader;